import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeliveryType } from '@iotv/datamodel';
import AddIcon from '@mui/icons-material/Add';
import { Autocomplete, Button, Divider, FormControl, FormLabel, Grid, Stack, TextField } from '@mui/material';
import { ActionIcons } from '../../../Iconography';
import { AutosizedPopper } from '../../common/AutosizedPopper';
import { AutosizedTextField } from '../../common/AutosizedTextField';
import { EditableList } from '../../generic/EditableList';
import { MultipleEntityAutoQuery } from '../../generic/EntityAutoQuery';
import { Escalation } from './EscalationConfig';
const debug = process.env.REACT_APP_DEBUG && false;
export const SubscriptionDeliveryOptions = {
    EMAIL: 'Email',
    MOBILE_PUSH: 'Mobile Push',
    SMS: 'SMS',
};
export const AdminOnlySubscriptionDeliveryOptions = [DeliveryType.SMS];
export const DeliveryOptions = ({ contextObject, deliveryOptions, setDeliveryOptions, additionalRecipients, isAdmin, contextUser }) => {
    debug && console.log('deliveryOption', deliveryOptions);
    debug && console.log(contextObject);
    const handleAdd = () => {
        const newDeliveryOption = {
            deliveryType: DeliveryType.EMAIL,
            destinations: [],
            recipients: [],
            messageContent: undefined,
            messageTitle: undefined,
            messageTemplate: undefined,
            escalations: [],
        };
        setDeliveryOptions([...deliveryOptions, newDeliveryOption]);
    };
    const handleRemove = (i) => {
        const mutant = [...deliveryOptions];
        mutant.splice(i, 1);
        setDeliveryOptions(mutant);
    };
    return (_jsxs(Stack, { gap: 1, children: [deliveryOptions.map((delivery, i) => {
                const key = `${i}_${delivery.deliveryType}_${delivery.destinations.join()}`;
                const disabled = !isAdmin && AdminOnlySubscriptionDeliveryOptions.find((t) => t === delivery.deliveryType) !== undefined;
                const mutateDeliveryOption = (deliveryOption) => {
                    const newDeliveryOptions = [...deliveryOptions];
                    newDeliveryOptions[i] = deliveryOption;
                    setDeliveryOptions(newDeliveryOptions);
                };
                const deliveryType = delivery.deliveryType !== DeliveryType.RAWEMAIL ? delivery.deliveryType : DeliveryType.EMAIL;
                const setDeliveryType = (deliveryType) => {
                    const newDeliveryOptions = [...deliveryOptions];
                    newDeliveryOptions[i].deliveryType = deliveryType;
                    setDeliveryOptions(newDeliveryOptions);
                };
                const setDestinations = (destinations) => {
                    const newDeliveryOptions = [...deliveryOptions];
                    newDeliveryOptions[i].destinations = destinations;
                    setDeliveryOptions(newDeliveryOptions);
                };
                const addEscalation = () => {
                    const newDeliveryOption = { ...delivery };
                    if (newDeliveryOption.escalations === undefined) {
                        newDeliveryOption.escalations = [];
                    }
                    newDeliveryOption.escalations.push({
                        afterDurationMs: undefined,
                        recipient: undefined,
                    });
                    mutateDeliveryOption(newDeliveryOption);
                };
                const setEscalation = (escalation, i) => {
                    const newDeliveryOption = { ...delivery };
                    if (newDeliveryOption.escalations === undefined) {
                        newDeliveryOption.escalations = [];
                    }
                    if (escalation !== undefined) {
                        newDeliveryOption.escalations[i] = escalation;
                    }
                    else {
                        newDeliveryOption.escalations = newDeliveryOption.escalations.toSpliced(i, 1);
                    }
                    mutateDeliveryOption(newDeliveryOption);
                };
                const currentEntities = delivery.recipients;
                const setCurrentEntities = (vobs) => {
                    const newDeliveryOptions = [...deliveryOptions];
                    const recipients = vobs.map(({ pk, sk, type, id, name, email, phoneNumber, phone_number, username }) => ({
                        pk,
                        sk,
                        type,
                        id,
                        name,
                        email,
                        phoneNumber: phoneNumber ?? phone_number,
                        username,
                    }));
                    newDeliveryOptions[i].recipients = recipients;
                    setDeliveryOptions(newDeliveryOptions);
                };
                // convert single-user escalation to multiple escalations
                if (delivery.escalation && (delivery.escalations === undefined || !delivery.escalations?.length)) {
                    const newDeliveryOption = { ...delivery };
                    newDeliveryOption.escalations = [delivery.escalation];
                    newDeliveryOption.escalation = undefined;
                    mutateDeliveryOption(newDeliveryOption);
                }
                debug && console.log('current Entities', currentEntities);
                return (_jsx(Grid, { size: 12, children: _jsxs(Grid, { container: true, rowSpacing: 1, columnSpacing: 1, children: [_jsx(Grid, { size: { xs: 12, lg: 4 }, children: _jsxs(Grid, { container: true, rowSpacing: 1, children: [_jsxs(Grid, { sx: { height: '2.5em', display: 'flex', gap: 1, alignItems: 'center' }, size: 12, children: [_jsx(FormLabel, { children: "Delivery" }), _jsx(Button, { variant: "outlined", color: "error", size: "small", startIcon: _jsx(ActionIcons.Delete, {}), onClick: () => handleRemove(i), disabled: disabled, children: "Remove Delivery" })] }), _jsx(Grid, { size: 12, children: _jsx(FormControl, { fullWidth: true, children: _jsx(Autocomplete, { id: 'selectDeliveryType',
                                                    value: deliveryType,
                                                    options: Object.keys(SubscriptionDeliveryOptions).filter(isAdmin ? (x) => x : (o) => !AdminOnlySubscriptionDeliveryOptions.find((d) => d === o)),
                                                    getOptionLabel: (o) => SubscriptionDeliveryOptions[o],
                                                    size: 'small',
                                                    variant: 'outlined',
                                                    freeSolo: false,
                                                    multiple: false,
                                                    filterSelectedOptions: true,
                                                    onChange: (e, v) => {
                                                        setDeliveryType(v);
                                                    },
                                                    renderInput: (params) => (_jsx(Grid, { children: _jsx(TextField, { ...params,
                                                            label: 'Method' }) })), disabled: disabled }) }, 'B') }), _jsx(Grid, { size: 12, children: contextObject &&
                                                (isAdmin ? (_jsx(MultipleEntityAutoQuery, { contextObject: contextObject, currentEntities: currentEntities, setCurrentEntities: setCurrentEntities, label: "Recipients", entityType: "User", fullWidth: true, required: true, injectedOptions: [...additionalRecipients[deliveryType]], disabled: disabled })) : (_jsx(FormControl, { fullWidth: true, children: _jsx(Autocomplete, { options: [contextUser, ...additionalRecipients[deliveryType]], multiple: true, disabled: disabled, size: 'small', fullWidth: true, renderInput: (p) => _jsx(AutosizedTextField, { ...p, label: 'Recipients' }), getOptionLabel: (o) => o.name ?? o.sk, isOptionEqualToValue: (o, v) => v.sk === o.sk, value: currentEntities, onChange: (e, v) => {
                                                            setCurrentEntities(v);
                                                        }, slots: {
                                                            popper: AutosizedPopper,
                                                        } }) }))) }), [DeliveryType.EMAIL, DeliveryType.SMS].includes(deliveryType) && (_jsx(Grid, { size: 12, children: _jsxs(Grid, { container: true, rowSpacing: 1, size: 12, children: [delivery.destinations.length > 0 && (_jsx(Grid, { size: 12, children: _jsx(EditableList, { currentList: delivery.destinations, setCurrentList: (items) => setDestinations(items), label: delivery.deliveryType === DeliveryType.EMAIL ? 'Email address' : 'Phone number', placeholder: delivery.deliveryType === DeliveryType.EMAIL ? 'user@example.org' : '021 123 4567', disabled: disabled, requireSave: false }) })), _jsx(Grid, { size: 12, children: _jsx(Button, { fullWidth: true, startIcon: _jsx(AddIcon, {}), variant: 'outlined', color: 'primary', disabled: disabled, onClick: () => setDestinations([...delivery.destinations, '']), children: "Add other destination" }) })] }) }))] }) }), _jsx(Grid, { size: { xs: 12, lg: 6 }, children: _jsxs(Stack, { gap: 1, children: [_jsx(FormLabel, { children: "Escalations" }), delivery.escalations?.map((escalation, i) => {
                                            return (_jsx(Escalation, { escalation: escalation, setEscalation: (e) => setEscalation(e, i), contextObject: contextObject, disabled: disabled }, i));
                                        }), _jsx(Stack, { direction: "row", children: _jsx(Button, { variant: "outlined", color: "primary", startIcon: _jsx(AddIcon, {}), onClick: () => addEscalation(), disabled: disabled, children: "Add escalation" }) })] }) })] }, key) }, key));
            }), _jsx(Divider, {}), _jsx(Stack, { direction: 'row', children: _jsx(Button, { size: 'small',
                    variant: 'contained',
                    color: 'primary',
                    startIcon: _jsx(AddIcon, {}),
                    onClick: handleAdd, children: "Add Delivery" }) })] }));
};
